import { error } from '@xhs/logger'
import BaseUploader from './BaseUploader'

export default class TokenUniqueUploader extends BaseUploader {
  constructor({
    getToken,
    bucket,
    bizKey,
    keyPattern,
    postFile,
    useAccelerate,
  }) {
    super({
      bucket, bizKey, keyPattern, getToken, postFile, useAccelerate,
    })
  }

  post(args) {
    const logPayload = {
      bucket: this.bucket,
      bizKey: this.bizKey,
      useAccelerate: this.useAccelerate,
      keyPattern: this.keyPattern,
    }
    return this.getToken(args).then(data => this.postFile({ ...args, ...data }).catch(err => {
      error('upload error', {
        args,
        err,
        ...logPayload,
      }, 'uploader')
    })).catch(err => {
      error('get token error', {
        args,
        err,
        ...logPayload,
      }, 'uploader')
    })
  }
}
